export default "__VITE_ASSET__D3pD4dmD__"